import React, {Component} from 'react';
import {Api} from '../../api';
import TextFieldInput from '../Common/TextFieldInput'
import ButtonInput from '../Common/ButtonInput'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {InputAdornment, IconButton} from '@material-ui/core';
import {withRouter} from 'react-router';
import queryString from 'query-string';
import Loader from '../Common/Loader'
import {PropyLogoIcon} from '../Common/Icons/Icons'
import './NewPassword.scss';

class NewPassword extends Component {

    state = {
        password: '',
        matchingPassword: '',
        errorMessage: '',
        showPassword: false,
        showMatchingPassword: false,
        sentConfirmation: false,
        token: null,
        id: null,
        isLoading: false
    };

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);
        this.setState({
            token: params.token,
            id: params.id
        });
    }

    render() {
        const {
            password, showPassword, showMatchingPassword, matchingPassword, sentConfirmation, isLoading
        } = this.state;

        return (
            <div className="new-password-popup">
                { isLoading && <Loader/> }
                <form className={'new-password-popup__form ' + (sentConfirmation && ' email-sent')}>
                    <div className={'form-wrapper'}>
                    <header className="new-password-popup__header">
                        <h2 className="new-password-popup__title">New password</h2>
                    </header>
                    <div className="new-password-popup__body">
                        <div className="fields-row m-b-5">
                            <TextFieldInput name='password'
                                            label='Password'
                                            type={showPassword ? 'text' : 'password'}
                                            classes='width-400 p-r-0'
                                            value={password}
                                            required={true}
                                            endAdornment={{
                                                endAdornment: (
                                                    <InputAdornment position="end" classes={{
                                                        root: 'root-input-adornment'
                                                    }}>
                                                        <IconButton
                                                            aria-label="Toggle password visibility"
                                                            onClick={() => this.setState({showPassword: !showPassword})}
                                                            onMouseDown={this.handleMouseDownPassword}
                                                        >
                                                            {showPassword ? <VisibilityOff/> :
                                                                <Visibility/>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            handleChange={(e) => this.handleChange(e)}/>
                        </div>
                        <div className="fields-row m-b-10">
                                <span
                                    className="input-tip">8 characters include: 1 uppercase, 1 digit, 1 lowercase</span>
                        </div>
                        <div className="fields-row">
                            <TextFieldInput name='matchingPassword'
                                            label='Confirm Password'
                                            type={showMatchingPassword ? 'text' : 'password'}
                                            classes='width-400 p-r-0'
                                            value={matchingPassword}
                                            required={true}
                                            endAdornment={{
                                                endAdornment: (
                                                    <InputAdornment position="end" classes={{
                                                        root: 'root-input-adornment'
                                                    }}>
                                                        <IconButton
                                                            aria-label="Toggle password visibility"
                                                            onClick={() => this.setState({showMatchingPassword: !showMatchingPassword})}
                                                            onMouseDown={this.handleMouseDownPassword}
                                                        >
                                                            {showMatchingPassword ? <VisibilityOff/> :
                                                                <Visibility/>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            handleChange={(e) => this.handleChange(e)}/>
                        </div>
                        <div className="fields-row">
                            <ButtonInput className='dark-button width-400'
                                         title='Submit'
                                         disabled={password.length < 8 || password.matchingPassword < 8}
                                         handleClick={(e) => this.onSubmit(e)}/>
                        </div>
                        <div className="fields-row">
                            <span onClick={() => this.props.history.push('/')}
                                  className='password-link'>← Back to login page</span>
                        </div>
                    </div>
                    </div>
                </form>
            </div>
        )
    }

    handleChange = event => {
        console.log(event.target.name, event.target.value, 'handle change')
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.formValidate()) {
            this.setState({isLoading: true});
            Api.post(`user/restore_password?id=${this.state.id}&token=${this.state.token}`, {
                newPassword: this.state.password,
                matchingPassword: this.state.matchingPassword,
            }).then((response) => {
                if (response.data.status !== '409') {
                    this.setState({
                        password: '',
                        matchingPassword: '',
                    });

                    alert(response.data);
                    this.props.history.push('/')
                }
                this.setState({isLoading: false});
                console.log(response, 'response')
            }).catch((error) => {
                this.setState({isLoading: false});
                alert(error.response.data);
            })
        }
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    formValidate = () => {
        const {username, password} = this.state;
        let isValid = true;

        return isValid;
    }
}

export default withRouter(NewPassword);


// WEBPACK FOOTER //
// ./src/components/NewPassword/NewPassword.js